import React from "react";

interface DateFormatterProps {
  date: string | Date;
  className?: string;
}

export const DateFormatter: React.FC<DateFormatterProps> = ({
  date,
  className = "text-center",
}) => {
  let formattedDate = String(date);

  if (date instanceof Date) {
    formattedDate = date.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } else if (typeof date === "string" && date) {
    const dateObj = new Date(date);
    if (!isNaN(dateObj.getTime())) {
      formattedDate = dateObj.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    }
  }

  return <div className={className}>{formattedDate}</div>;
};
